"use client";

type CheckoutSubmitButtonProps = {
  /** CI/CO 両方確定済みか。false の間はボタン非活性 */
  isConfirmed: boolean;
  /** 料金総額のフォーマット済み文字列。読み込み中・失敗時は null */
  total: string | null;
  estimateLoading: boolean;
  onSubmit: () => void;
  messages: { submitButton: string; totalPrefix: string; loadingPrice: string };
};

/**
 * フッターの「予約する」CTA (room-detail の cta-button.tsx と同じダーク pill)。
 * confirmed 時のみ「合計 {total}」を併記する (見積もり失敗時 total=null は合計非表示、ボタン活性のまま)。
 */
export function CheckoutSubmitButton({
  isConfirmed,
  total,
  estimateLoading,
  onSubmit,
  messages,
}: CheckoutSubmitButtonProps) {
  return (
    <div className="shrink-0 px-[16px] pt-[16px] pb-[16px]">
      <button
        data-analytics-id="reservation_calendar_submitted_checkout"
        type="button"
        disabled={!isConfirmed}
        onClick={onSubmit}
        className="bg-dx-button-dark-fill font-notojp text-dx-base-white flex h-[52px] w-full items-center justify-center gap-[12px] rounded-full text-[16px] leading-[1.6] font-bold shadow-[0px_6px_14px_rgba(0,0,0,0.1),0px_0px_0px_rgba(0,0,0,0.02)] disabled:opacity-60"
      >
        {messages.submitButton}
        {isConfirmed &&
          (estimateLoading ? (
            <span className="text-dx-base-white text-[16px] leading-[1.6] font-normal">
              {messages.totalPrefix} {messages.loadingPrice}
            </span>
          ) : total !== null ? (
            <span className="text-dx-base-white flex items-center gap-[4px]">
              <span className="text-[12px] leading-[1.6] font-normal">
                {messages.totalPrefix}
              </span>
              {/* 価格は Latin/数字のみ。プロジェクトの数字慣例に従い font-roboto。 */}
              <span className="font-roboto text-[16px] leading-[1.6] font-normal">
                {total}
              </span>
            </span>
          ) : null)}
      </button>
    </div>
  );
}
